import * as models from './models'

// make the models globally accessible for console debugging
window.models = models
